import { Button, CardContent, Typography, Drawer, Table, TableHead, TableRow, Divider, tableCellClasses, TableCell, TableBody, IconButton, Dialog, DialogTitle, DialogContent, Grid } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import CustomDataGrid from '../DataGrid/DataGrid';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import { ApiStatus } from "../../utils/api.types";
import Link from '@mui/material/Link';
import { /* deleteDocumentSetting, */ fetchDocumentSettings } from '../../store/documentSettingStore/documentSettingThunk';
import { Box } from '@mui/system';
import { GridActionsCellItem, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { IDocumentSetting } from '../../utils/documentSetting.types';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
import { PermissionsEnum } from "../../utils/auth.types";
import DialogDocumentSettingForm from '../DialogDocumentSettingForm/DialogDocumentSettingForm';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import styled from '@emotion/styled';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';

interface AccountDocumentSettingsInfoProps {
  accountId: string;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fff',
    color: '#9da7b7',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    margin: 0,
    padding: 5,
    fontSize: 13,
    paddingLeft: '15px !important',
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    border: 'none',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fbfbfb',
    // border: '0.5px dashed #9da7b7',
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#e9ecf1',
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
  },
}));

const AccountDocumentSettingInfo: FC<AccountDocumentSettingsInfoProps> = (props) => {
  const dispatch = useAppDispatch();

  const { documentSettings, status } = useAppSelector(state => state.documentSettings);
  const { permissions } = useAppSelector(state => state.auth);

  const [open, setOpen] = useState(false);
  const [documentSettingId, setDocumentSetting] = useState('');
  const [fetchData, setFetchData] = useState('');
  const [viewLedgersOpen, setViewLedgersOpen] = useState(false);
  const [selectedLedgers, setSelectedLedgers] = useState<any[]>([]);

  // const canCreateAccount = permissions?.includes(PermissionsEnum.Account_Create);
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);
  // const canViewAccount = permissions?.includes(PermissionsEnum.Account_View);
  // const canDeleteAccount = permissions?.includes(PermissionsEnum.Account_Delete);


  /**
   * Fetch all the accounts on Accounts page load.
   */
  useEffect(() => {
    dispatch(fetchDocumentSettings(props.accountId));
  }, [dispatch, fetchData, props]);

  /**
   * Handler for account name click.
   */
  const handleNameClick = useCallback((documentSetting: IDocumentSetting) => {
    openDocumentSettingForm(documentSetting._id);
  }, []);

  /**
  * Method to handle delete account.
  */
  // const deleteSelectedDocumentSetting = useCallback((item: IDocumentSetting) => () => {
  //   // Dispatch action to delete account.
  //   dispatch(deleteDocumentSetting(item._id));
  // }, [dispatch]);

  /**
   * Method to handle delete item.
   */
  // const deleteSelected = useCallback((item: IDocumentSetting) => () => {
  //   // Dispatch action to delete.
  //   dispatch(deleteDocumentSetting(item._id));
  // }, [dispatch]);

  /**
   * Method to handle edit.
   */
  // const editSelected = useCallback((item: IDocumentSetting) => () => {

  // }, [dispatch]);

  /**
   * Column defs for account list data grid.
   */
  const columns: GridColDef[] = useMemo(() => [
    {
      field: "documentType",
      headerName: 'Type',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography
          sx={{ cursor: 'pointer', fontWeight: 'bold' }}
          component={Link}
          underline='hover'
          onClick={() => handleNameClick(row)}
        >
          {value?.name || '-'}
        </Typography>
      )
    },
    {
      field: "docNumberPrefix",
      headerName: 'Prefix',
      type: "string",
      flex: 1
    },
    {
      field: "docSequenceNumber",
      headerName: 'Sequence',
      type: "string",
      flex: 1
    },
    {
      field: "docNumberLength",
      headerName: 'Length',
      type: "string",
      flex: 1
    },
    {
      field: "status",
      headerName: 'Status',
      type: "string",
      flex: 1
    },

    {
      field: "actions",
      headerName: 'Actions',
      type: "actions",
      flex: 1,
      getActions: (params: GridValueGetterParams) => {
        const editAction = (
          <GridActionsCellItem
            icon={<EditIcon />}
            title="Edit"
            label="Edit"
            sx={{ paddingLeft: "28px", "&:hover": { backgroundColor: 'transparent' }, "&:focus": { backgroundColor: 'transparent' } }}
            onClick={() => handleNameClick(params.row)}
          />
        );

        // const deleteAction = (
        //   <GridActionsCellItem
        //     icon={<DeleteIcon />}
        //     title="Delete"
        //     label="Delete"
        //     onClick={deleteSelectedDocumentSetting(params.row)}
        //   />
        // );

        const actions: JSX.Element[] = [];

        // Push edit action if user has update permission.
        if (canUpdateAccount) {
          actions.push(editAction);
        }

        // Push edit action if user has delete permission.
        // if (canDeleteAccount) {
        //   actions.push(deleteAction);
        // }

        return actions;
      }
    }
  ], [
    // deleteSelected,
    // editSelected,
    canUpdateAccount,
    // canDeleteAccount,
    handleNameClick
  ]);

  const openDocumentSettingForm = (documentSettingId: string) => {
    setDocumentSetting(documentSettingId);
    setOpen(true);
  }

  const closeDialog = (isSaved: boolean) => {
    setOpen(false);

    if (isSaved) {
      setFetchData(Math.random().toString());
    }
  }

  const handleViewLedgers = (ledgers: any[]) => {
    setSelectedLedgers(ledgers || []);
    setViewLedgersOpen(true);
  }

  const handleCloseLedgersModal = () => {
    setViewLedgersOpen(false);
    setSelectedLedgers([]);
  }

  return (
    <div className={'c-card2'} style={{ padding: 0 }}>
      <Button
        size='small'
        variant="contained"
        style={{
          float: "right",
          marginRight: 10,
          marginTop: 10,
          color: '#488dff',
          backgroundColor: '#fff',
          border: '0.5px solid #488dff',
          height: 25, borderRadius: 7
        }}
        onClick={() => { openDocumentSettingForm('') }}
      >Add Document Settings
      </Button>
      <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 10, marginBottom: 10 }}>Document Settings</h5>

      {documentSettings && documentSettings.length > 0 ?
        <div style={{ marginBottom: 12, marginTop: 5 }}>
          <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell width={200}>Type</StyledTableCell>
                <StyledTableCell width={180}>Prefix</StyledTableCell>
                <StyledTableCell width={120}>Sequence</StyledTableCell>
                <StyledTableCell width={100}>Length</StyledTableCell>
                <StyledTableCell width={100}>Status</StyledTableCell>
                <StyledTableCell width={150}>Configured Ledgers</StyledTableCell>
                <StyledTableCell width={100}>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documentSettings.map((e: any) =>
                <StyledTableRow key={e._id}>
                  <StyledTableCell>{e.documentType?.name}</StyledTableCell>
                  <StyledTableCell>{e.docNumberPrefix}</StyledTableCell>
                  <StyledTableCell>{e.docSequenceNumber}</StyledTableCell>
                  <StyledTableCell>{e.docNumberLength}</StyledTableCell>
                  <StyledTableCell>{e.status}</StyledTableCell>
                  <StyledTableCell>
                    {e.ledgers && e.ledgers.length > 0 ? (
                      <Button
                        onClick={() => handleViewLedgers(e.ledgers)}
                        size='small'
                        variant="text"
                        style={{
                          color: '#488dff',
                          textTransform: 'none',
                          fontSize: 12,
                          padding: '2px 8px',
                          minWidth: 'auto'
                        }}
                      >
                        View Ledger
                      </Button>
                    ) : (
                      <span style={{ fontSize: 12, color: '#999', padding: '2px 8px', display: 'inline-block' }}>No ledgers</span>
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    <IconButton
                      onClick={() => handleNameClick(e)}
                      style={{ color: '#488dff', backgroundColor: '#fff', height: 25, width: 25 }}
                      size='small' ><EditIcon style={{ fontSize: 16 }} />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        // const rows = documentSettings.filter((obj) => obj._id !== e._id);
                        // setDocumentSetting(rows);
                      }}
                      style={{ color: '#c33b3b', backgroundColor: '#fff', height: 25, width: 25, marginLeft: 10 }}
                      size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                    </IconButton>
                  </StyledTableCell>
                  {/* <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell> */}
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </div> :
        <div style={{ height: 200 }}>
          <Divider sx={{ mt: 0.5, mb: 1 }} />
          No Data</div>
      }
      <Drawer
        anchor="right"
        open={open}
      >
        {open && <DialogDocumentSettingForm open={open} documentSettingId={documentSettingId} onClose={closeDialog}></DialogDocumentSettingForm>}
      </Drawer>

      {/* View Ledgers Modal */}
      <Dialog
        open={viewLedgersOpen}
        onClose={handleCloseLedgersModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: '#e9ecf1', fontWeight: 'bold', fontSize: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Configured Ledgers</span>
          <Button
            onClick={handleCloseLedgersModal}
            size='small'
            variant="outlined"
          >
            Close
          </Button>
        </DialogTitle>
        <DialogContent style={{ paddingTop: 20 }}>
          {selectedLedgers.length > 0 ? (
            <Grid container spacing={2}>
              {selectedLedgers.map((ledger: any, index: number) => (
                <Grid item xs={6} key={ledger._id}>
                  <div
                    style={{
                      backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
                      borderRadius: 5,
                      padding: '12px',
                      border: '1px solid #e0e0e0'
                    }}
                  >
                    <div style={{ fontWeight: 'bold', color: '#292d35', marginBottom: 4 }}>
                      {ledger.ledgerName}
                    </div>
                    <div style={{ fontSize: 12, color: '#666' }}>
                      Code: {ledger.accountingCode} | Seq: {ledger.seqNumber}
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
          ) : (
            <p style={{ textAlign: 'center', color: '#999' }}>No ledgers configured</p>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AccountDocumentSettingInfo;
